<template>
  <div>
    <b-card>
      <div class="organism-credential_header card-padding">
        <span class="header__label">Credential Management</span>
        <atom-button
          v-if="hasUpdatePermission"
          buttonId="create-new-credential"
          buttonStyle="border"
          :isDisable="!currentVeeamId || !getVeeamStatus"
          @click="clickCreateCredential"
        >
          <div class="d-flex d-md-none">Create</div>
          <div class="d-none d-md-flex">Create New Credential</div>
        </atom-button>
      </div>
      <div class="filter-container card-padding pt-0 pb-3">
        <div class="row mt-0">
          <div
            class="col-12 col-md-5 mb-1 mb-md-0 d-flex justify-content-between"
          >
            <atom-input
              v-model="filterList.username"
              title="Username"
              placeholder="Username"
              :isDisable="!currentVeeamId"
            ></atom-input>
            <div class="d-flex align-items-end">
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                class="search__button ml-2"
                :isDisable="!currentVeeamId || !getVeeamStatus"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                :class="{ 'disabled-button': !currentVeeamId }"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <b-table
            sticky-header
            responsive
            :items="items"
            :fields="hasUpdatePermission ? fields : fields.filter(field => field.key !== 'deleteIcon')"
            :hover="true"
            @row-clicked="selectRow"
          >
            <template #cell(username)="data">
              <div>{{ data.value }}</div></template
            >
            <template #cell(type)="data">
              <div>{{ data.value }}</div></template
            >
            <template #cell(description)="data">
              <div>{{ data.value }}</div></template
            >
            <template #cell(creationTime)="data">
              <div>{{ data.value.date }}</div>
              <div class="sub-header">{{ data.value.time }}</div></template
            >
            <template #cell(deleteIcon)="data">
              <div :id="'button-delete-credential' + data.item.id">
                <atom-button
                  buttonId="button-delete"
                  iconLeft="Trash2Icon"
                  buttonStyle="flat"
                  buttonColor="secondary"
                  :isDisable="serverCredentialList.includes(data.item.id)"
                  @click="clickDeleteCredential(data)"
                ></atom-button>
              </div>
              <b-tooltip
                v-if="serverCredentialList.includes(data.item.id)"
                :target="'button-delete-credential' + data.item.id"
                placement="left"
                boundary="window"
                variant="danger"
              >
                Credential is used for Veeam server and can't be delete
              </b-tooltip>
            </template>
          </b-table>
        </div>
        <div
          v-if="!currentVeeamId"
          class="w-100 d-flex flex-column justify-content-center align-items-center p-4"
        >
          <feather-icon
            icon="CloudOffIcon"
            class="empty-data__icon"
          ></feather-icon>
          <label class="empty-data__text--title">No Credential</label>
          <label v-if="!currentVeeamId" class="empty-data__text--body"
            >Please Select Veeam</label
          >
        </div>
      </div>
      <div class="row card-padding">
        <div class="col-6">Showing {{ items.length }} entries</div>
        <div v-if="currentVeeamId" class="col-6 d-flex justify-content-end">
          <div
            v-if="filterList.totalCount"
            class="col-6 d-flex justify-content-end"
          >
            <b-pagination
              v-model="filterList.currentPage"
              :total-rows="filterList.totalCount"
              :per-page="perPage"
              size="sm"
              class="my-0"
            ></b-pagination>
          </div>
        </div>
      </div>
    </b-card>
    <footer style="height: 28px"></footer>
    <section name="create-credential">
      <molecule-modal-dialog
        modalId="create-credential"
        :isTextCenter="true"
        buttonTextLeft="Create Credential"
        textTitle="Create Credential"
        :isSlotBody="true"
        :isCloseOnBackDrop="false"
        :isDisableButtonLeft="isErrorValidate"
        @clickButtonLeft="clickConfirmCreateCredential"
        ><template #body>
          <div class="row mt-0">
            <div class="col-12 col-md-8 mt-2">
              <atom-input
                v-model="credential.username"
                title="Username"
                placeholder="Username"
                :isAsterisk="true"
                :isError="isErrorUsername"
                errorMessage="Username is required"
              ></atom-input>
            </div>
            <div class="col-12 col-md-4 mt-2 pl-md-0">
              <atom-select
                v-model="credential.type"
                title="Type"
                placeholder="Type"
                label="type"
                :isAsterisk="true"
                :isClearable="false"
                :isAppendToBody="false"
                :isEnableProper="false"
                :option="typeList"
                :isError="isErrorType"
                errorMessage="Type is required"
              ></atom-select>
            </div>
            <div class="col-12 mt-2">
              <atom-input
                v-model="credential.password"
                title="Password"
                placeholder="Password"
                type="password"
                :isAsterisk="true"
                :isError="isErrorPassword"
                errorMessage="Password is required"
              ></atom-input>
            </div>
            <div v-if="credential.type === 'Linux'" class="col-12 mt-2">
              <atom-checkbox
                v-model="credential.autoElevated"
                title="Auto elevate to root"
              ></atom-checkbox>
            </div>
            <div class="col-12 mt-2">
              <atom-text-area
                v-model="credential.description"
                title="Description"
                placeholder="Description"
                :rows="3"
                :isAsterisk="true"
                :isError="isErrorDescription"
                errorMessage="Description is required"
              ></atom-text-area>
            </div>
            <div class="col-12 mt-2">
              <atom-multi-select
                placeholder="Select Veeam"
                title="Select Veeam"
                :option="veeamList"
                v-model="credential.veeam"
                label="name"
                :isAsterisk="true"
                :isError="isErrorSelectVeeam"
                errorMessage="Please select veeam"
              ></atom-multi-select>
            </div></div></template
      ></molecule-modal-dialog>
    </section>

    <section name="edit-credential">
      <molecule-modal-dialog
        modalId="edit-credential"
        :isTextCenter="true"
        textTitle="Credential Detail"
        buttonTextLeft="Save changes"
        :isSlotBody="true"
        :isCloseOnBackDrop="false"
        :isDisableButtonLeft="isErrorEditValidate"
        :isButtonLeft="hasUpdatePermission"
        :isButtonRight="hasUpdatePermission"
        @clickButtonLeft="clickConfirmEditCredential"
        ><template #body>
          <div class="row">
            <div class="col-12 col-md-8 mt-2">
              <atom-input
                v-model="credential.username"
                title="Username"
                placeholder="Username"
                :isAsterisk="true"
                :isError="isErrorUsername"
                errorMessage="Username is required"
                :isDisable="!hasUpdatePermission"
              ></atom-input>
            </div>
            <div class="col-12 col-md-4 mt-2 pl-md-0">
              <atom-select
                v-model="credential.type"
                title="Type"
                placeholder="Type"
                label="type"
                :isDisable="true"
                :isClearable="false"
                :isAppendToBody="false"
                :isEnableProper="false"
                :option="typeList"
                :isError="isErrorType"
                errorMessage="Type is required"
              ></atom-select>
            </div>
            <div class="col-12 mt-2">
              <atom-input
                v-model="credential.password"
                title="Password"
                placeholder="Password"
                type="password"
                :isDisable="!hasUpdatePermission"
              ></atom-input>
            </div>
            <div v-if="credential.type === 'Linux'" class="col-12 mt-2">
              <atom-checkbox
                v-model="credential.autoElevated"
                title="Auto elevate to root"
                :isDisable="!hasUpdatePermission"
              ></atom-checkbox>
            </div>
            <div class="col-12 mt-2">
              <atom-text-area
                v-model="credential.description"
                title="Description"
                placeholder="Description"
                :isAsterisk="true"
                :rows="3"
                :isError="isErrorDescription"
                errorMessage="Description is required"
                :isDisable="!hasUpdatePermission"
              ></atom-text-area>
            </div></div></template
      ></molecule-modal-dialog>
    </section>

    <section name="delete-credential">
      <molecule-modal-dialog
        modalId="delete-credential"
        :isTextCenter="true"
        icon="AlertCircleIcon"
        textTitle="Do you want to delete?"
        buttonTextLeft="Delete"
        buttonColorLeft="danger"
        :isDisableButtonLeft="false"
        :isSlotBody="true"
        @clickButtonLeft="confirmDelete"
        ><template #body>
          <div class="w-70 pl-3 pl-sm-4">
            <div>
              <label class="width-85px">username:</label>
              <b>{{ deleteMessage.username }}</b>
            </div>
            <div>
              <label class="width-85px">description: </label
              ><b>{{ deleteMessage.description }}</b>
            </div>
          </div>
        </template>
      </molecule-modal-dialog>
    </section>
  </div>
</template>

<script>
import { BCard, BTable, BPagination, BBadge, BTooltip } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixinsValidator from "@/mixins/mixinsValidator"
import { mapGetters } from "vuex"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismCredential",
  components: {
    BCard,
    BTable,
    BPagination,
    BBadge,
    BTooltip,
    AtomButton,
    AtomInput,
    AtomTextArea,
    AtomSelect,
    AtomMultiSelect,
    AtomCheckbox,
    MoleculeModalDialog,
  },
  mixins: [mixinsValidator, mixinsUser],
  props: {
    filterList: {
      required: true,
      type: Object,
    },
    currentVeeamId: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    veeamList: {
      type: Array,
      required: false,
      default: () => [],
    },
    serverCredentialList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isValidateTrigger: false,
      perPage: 10,
      credential: {
        id: "",
        username: "",
        type: "",
        password: "",
        description: "",
        veeam: "",
        autoElevated: false,
      },
      typeList: ["Standard", "Linux"],
      deleteMessage: {
        username: "",
        description: "",
      },
      deleteCredential: {
        id: "",
      },
    }
  },
  computed: {
    ...mapGetters("app", ["getVeeamStatus"]),

    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.BMM.CREDENTIAL_WRITE)
    },

    isErrorUsername() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.credential.username)
        : false
    },
    isErrorType() {
      return this.isValidateTrigger
        ? this.isEmptyObject(this.credential.type)
        : false
    },
    isErrorPassword() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.credential.password)
        : false
    },
    isErrorDescription() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.credential.description)
        : false
    },
    isErrorSelectVeeam() {
      return this.isValidateTrigger
        ? this.isEmptyObject(this.credential.veeam)
        : false
    },
    isErrorValidate() {
      return (
        this.isErrorUsername ||
        this.isErrorType ||
        this.isErrorPassword ||
        this.isErrorDescription ||
        this.isErrorSelectVeeam
      )
    },
    isErrorEditValidate() {
      return this.isErrorUsername || this.isErrorType || this.isErrorDescription
    },
  },
  watch: {
    "filterList.currentPage": {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit("onUpdateCurrentPage", this.filterList)
        }
      },
    },
  },
  methods: {
    selectRow(row) {
      this.credential.id = row.id
      this.credential.username = row.username
      this.credential.type = row.type
      this.credential.password = ""
      this.credential.description = row.description
      this.credential.autoElevated = row.autoElevated
      this.openModal("edit-credential")
    },
    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },
    clickButtonClearFilter() {
      if (this.currentVeeamId) {
        this.$emit("onSetDefaultFilterData")
      }
    },
    clickCreateCredential() {
      this.clearCredential()
      this.openModal("create-credential")
    },
    clickConfirmCreateCredential() {
      this.isValidateTrigger = true
      if (!this.isErrorValidate) {
        let createCredential = {
          username: this.credential.username,
          type: this.credential.type,
          password: this.credential.password,
          description: this.credential.description,
          autoElevated: this.credential.autoElevated,
          sshPort: 0,
        }
        if (this.credential.type === "Linux") {
          createCredential.sshPort = 22
        }
        const veeam = this.credential.veeam
        this.$emit("createCredential", createCredential, veeam)
        this.closeModal()
      }
    },
    clickConfirmEditCredential() {
      this.isValidateTrigger = true
      if (!this.isErrorEditValidate) {
        const id = this.credential.id
        let editCredential = {
          username: this.credential.username,
          type: this.credential.type,
          description: this.credential.description,
          autoElevated: this.credential.autoElevated,
          sshPort: 0,
        }
        if (this.credential.type === "Linux") {
          editCredential.sshPort = 22
        }
        const editPassword = {
          password: this.credential.password,
        }
        this.$emit("editCredential", id, editCredential, editPassword)
        this.closeModal()
      }
    },
    clickDeleteCredential(row) {
      this.deleteMessage.username = row.item.username
      this.deleteMessage.description = row.item.description
      this.deleteCredential.id = row.item.id
      this.openModal("delete-credential")
    },
    confirmDelete() {
      this.$emit("deleteCredential", this.deleteCredential.id)
      this.closeModal()
    },
    openModal(id) {
      if (this.modalId) this.closeModal()
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
      this.isValidateTrigger = false
    },
    clearCredential() {
      this.credential.id = ""
      this.credential.username = ""
      this.credential.type = ""
      this.credential.password = ""
      this.credential.description = ""
      this.credential.autoElevated = false
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-credential_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-container {
  border-bottom: 1px solid #e9ecef;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.card-padding {
  padding: 1.5rem;
}

.card-body {
  padding: 0;
}

.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
}

.width-85px {
  width: 85px;
}

.empty-data__icon {
  width: 100px;
  height: 100px;
}

.empty-data__text--title {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
  margin-top: 20px;
}

.empty-data__text--body {
  color: #b9b9c3;
  font-size: 14px;
  margin-top: 10px;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:not(.disabled-button):hover {
    cursor: pointer;
    color: #7367f0;
  }
}
</style>
